var checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = void 0;

errorCallback = void 0;


/*
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   location        - Location object returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(location) {
  var lat, lng, ref;
  ref = location != null ? location.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  setInterval(checkCurrentLocation, 1000 * 60 * 5);
  cllCookie.set(location);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/*
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvaGVscGVyL21fZGV0ZWN0Q3VycmVudExvY2F0aW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2hlbHBlci9tX2RldGVjdEN1cnJlbnRMb2NhdGlvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxzR0FBQTtFQUFBOztBQUFFLFlBQWMsT0FBQSxDQUFRLHFCQUFSOztBQUNoQixlQUFBLEdBQWtCOztBQUNsQixhQUFBLEdBQWtCOzs7QUFFbEI7Ozs7Ozs7O0FBT0EsT0FBQSxHQUFVLFNBQUMsUUFBRDtBQUNSLE1BQUE7RUFBQSx5QkFBa0MsUUFBUSxDQUFFLGVBQTVDLEVBQVcsVUFBVixRQUFELEVBQTJCLFVBQVg7RUFDaEIsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFkLENBQXlCLDZCQUF6QixFQUF3RDtJQUFDLEtBQUEsR0FBRDtJQUFNLEtBQUEsR0FBTjtHQUF4RDtFQUNBLFdBQUEsQ0FBWSxvQkFBWixFQUFrQyxJQUFBLEdBQU8sRUFBUCxHQUFZLENBQTlDO0VBQ0EsU0FBUyxDQUFDLEdBQVYsQ0FBYyxRQUFkO2lEQUNBLGdCQUFpQjtJQUFDLEtBQUEsR0FBRDtJQUFNLEtBQUEsR0FBTjtJQUFXLE9BQUEsRUFBUyxJQUFwQjs7QUFMVDs7O0FBT1Y7Ozs7Ozs7O0FBT0EsS0FBQSxHQUFRLFNBQUMsR0FBRDtFQUNOLE9BQU8sQ0FBQyxLQUFLLENBQUMsVUFBZCxDQUF5Qix5QkFBekIsRUFBb0QsR0FBcEQ7RUFDQSxTQUFTLENBQUMsTUFBVixDQUFpQixHQUFqQjsrQ0FDQSxjQUFlO0FBSFQ7OztBQUtSOzs7Ozs7OztBQU9BLG9CQUFBLEdBQXVCLFNBQUMsZUFBRCxFQUF1QixTQUF2QixFQUFrRCxPQUFsRDs7SUFBQyxrQkFBa0I7OztJQUFJLFlBQVksU0FBUyxDQUFDOzs7SUFBSyxVQUFVLFNBQVMsQ0FBQzs7RUFDM0YsSUFBRyxlQUFlLENBQUMsVUFBaEIsSUFBOEIsZUFBZSxDQUFDLE9BQWpEO0lBQ0UsU0FBUyxDQUFDLFdBQVcsQ0FBQyxrQkFBdEIsQ0FBeUMsU0FBekMsRUFBb0QsT0FBcEQsRUFBNkQsZUFBN0QsRUFERjtHQUFBLE1BQUE7SUFHRSxTQUFTLENBQUMsV0FBVyxDQUFDLGtCQUF0QixDQUF5QyxTQUF6QyxFQUFvRCxPQUFwRCxFQUhGOztBQURxQjs7O0FBT3ZCOzs7Ozs7OztBQU9BLHFCQUFBLEdBQXdCLFNBQUE7QUFDdEIsTUFBQTtFQUR1QjtFQUN0Qix3QkFBRCxFQUFrQjtFQUNsQixJQUFBLENBQStCLFNBQVMsQ0FBQyxXQUF6QztBQUFBLGlEQUFPLHlCQUFQOztFQUNBLGVBQUEsNENBQW9DLENBQUUsNEJBQXBCLElBQTBDO1NBRTVELG9CQUFBLENBQXFCLGVBQXJCLEVBQXNDLE9BQXRDLEVBQStDLEtBQS9DO0FBTHNCOztBQVF4QixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNmLHNCQUFBLG9CQURlO0VBRWYsc0JBQUEsRUFBd0IsT0FGVDtFQUdmLG9CQUFBLEVBQXNCLEtBSFA7RUFJZix1QkFBQSxxQkFKZSJ9
